export default defineNuxtPlugin(nuxtApp => {
	function frosmoLoad() {
		useHead({
			script: [
				{
					src: `https://d2wzl9lnvjz3bh.cloudfront.net/frosmo.easy.js`,
					async: true,
					body: true,
				},
				{
					src: `https://d2wzl9lnvjz3bh.cloudfront.net/sites/bigbang_si.js`,
					async: true,
					body: true,
				},
			],
		});
	}

	frosmoLoad();
});
